module.exports = __webpack_public_path__ + "img/folder-dark-pink.3c989f0f.svg";